import React from 'react';
import $ from "jquery";
import { Button } from '@progress/kendo-react-buttons'
import { withRouter } from 'react-router-dom';
import lang from '../../lang';
import { TimeSelector } from '@progress/kendo-react-dateinputs/dist/npm/timepicker/TimeSelector';





class TitleBar extends React.Component {

    handleRouting = () => {
       
        this.props.history.push({
            pathname: `${this.props.path}`,
            state:{topBarMenu : this.props.topBarMenu}
        })
        if(this.props.path == "/fiscalizacao" || this.props.path == "/fiscalizacaoConcluidos" || this.props.path == "/FiscalizacaoRS"|| this.props.path == "/FiscalizacaoAgendamento"|| this.props.path == "/FiscalizacaoRequisicaoPrevia"){
            //alert("fiscalização") 
            window.location.href = `/inserirFiscalizacao`
        }
        // window.location.href = `${this.props.path}`
    }


    changeRoute = (url) => {
        this.props.history.push({
            pathname: url,
            state: {}
        });
    }

    // para voltar à página inicial
    
    goBack = () => {
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
//        this.props.history.go(-1);
// //        console.log(this.props.history);
        this.props.history.push({
            pathname : this.props.prevPageLink,
            state : {topBarMenu : topBarMenu, paramoption : {back:true}}
        })
    }

    handleInicio = () => {
        this.props.history.push({pathname : this.props.onlyInicioLink})
        // window.location.reload();
        this.props.refreshComponent();
    }
 
    /*  Para renderizar o conteúdo html da página   */

    render() {
        //console.log("this.props.TitleBarButtonName -> ", this.props.TitleBarButtonName)
        return (
            <div className="row">
                <div className="col-md-8 order-sm-1 order-2">
                    <div className="heading d-md-flex align-items-center">
                        {/* <img src="imgs/icon1_gray.png" alt=""/>  */
                        }
                        {/* {
                            this.props.linkData && this.props.linkData.TitleBartitle === 'Instalações Vínicas' ?
                            <img className="font-23 mr-3 ml-2 text-grey" src='/imgs/instalacoesvinicas-gray.svg' alt="" />
                            : */}
                            <span className={`sivdp-icon sivdp-${this.props.logo} font-23 mr-3 ml-2 text-grey`}></span>
                        {/* } */}
                        <h3>{this.props.title}</h3>
                        {
                            this.props.linkData && this.props.linkData.TitleBarPopUpButton &&
                            <Button data-toggle="modal" data-target="#vindima-Registar" primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary">+ Registar Impressão</Button>
                        }
                        {
                            this.props.path ? (
                                this.props.TitleBarButtonName ?
                                    <Button onClick={() => this.handleRouting()} primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary">{this.props.TitleBarButtonName && this.props.TitleBarButtonName.toUpperCase()}</Button>
                                    :

                                    this.props.linkData && this.props.linkData.tableName == 'SelosRequisiçãoPendentes' ? 
                                    <Button data-toggle="modal" data-target="#selos-graficas-popup" primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary" title="Inserir">+ Inserir</Button>
                                    :
                                    this.props.linkData && this.props.linkData.tableName == 'SelosRastreabilidade' ? 
                                    <span></span>
                                    :
                                    this.props.linkData && this.props.linkData.tableName == 'FiscInsercaoSelosEtiquetas' ? 
                                    <Button data-toggle="modal" data-target="#FiscalizacaoInsercaoSelosEtiquetas-popup" primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary" title="Inserir">+ Inserir</Button>
                                    :
                                    this.props.title==="Estatuto"?null:
                                    <Button onClick={() => this.handleRouting()} primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary" title="Inserir">+ Inserir</Button>
                            )
                                :
                                ''
                        }
                        {
                            this.props.linkData && this.props.linkData.nevOptionLinks &&
                            <div className="dropdown">
                                <Button primary={true} className="btn-ivdp-primary btn-theme mr-2 k-primary dropdown-toggle" data-toggle="dropdown">
                                    {("Menu").toUpperCase()} <i className="fas fa-sort-down ml-1 mb-1"></i>
                                </Button>
                                <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                                    {
                                        this.props.linkData.nevOptionLinks.map((row) => (
                                            row.url === this.props.linkData.currentPath ?
                                                <li className="dropdown-item active"><a href={row.url}>{row.name}</a></li>
                                                :
                                                <li className="dropdown-item"><a href={row.url}>{row.name}</a></li>

                                        ))
                                    }
                                </ul>
                            </div>
                        }
                        {/* {
                            this.props.linkData && this.props.linkData.nevOptionChange &&
                            <div className="dropdown">
                                <Button primary={true} className="btn-ivdp-primary btn-theme mr-2 k-primary dropdown-toggle" data-toggle="dropdown">
                                    {("Menu").toUpperCase()} <i className="fas fa-sort-down ml-1 mb-1"></i>
                                </Button>
                                <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                                    {
                                        this.props.linkData.nevOptionChange.map((row, i) => (
                                            row.name === this.props.linkData.prevPageName ?
                                                <li className="dropdown-item active" key={i}
                                                    onClick={(url) => this.changeRoute(row.url + "?u=" + row.url + "&p=" + row.name + "&t=" + row.tableName)}
                                                // onClick={(name,url)=>this.props.changeOption(row.name,row.url )} 
                                                ><a href="#">{row.name}</a></li>
                                                :
                                                <li className="dropdown-item" key={i}
                                                    onClick={(url) => this.changeRoute(row.url + "?u=" + row.url + "&p=" + row.name + "&t=" + row.tableName)}
                                                >
                                                    <a href="#">{row.name}</a>
                                                </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        } */}




                        {
                            this.props.pageName && this.props.TitleBarButtonName && this.props.TitleBarSecondButtonName &&
                            <>

                                <Button onClick={() => this.props.updateNavDropdown(this.props.TitleBarButtonName, this.props.pageName)} primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary">{
                                    lang.langCheck.langRequest(this.props.TitleBarButtonName)
                                }</Button>
                                <Button onClick={() => this.props.updateNavDropdown(this.props.TitleBarSecondButtonName, this.props.pageName)} primary={true} className="btn-ivdp-primary btn-theme mr-2  k-primary">{
                                    lang.langCheck.langRequest(this.props.TitleBarSecondButtonName)
                                }</Button>
                            </>
                        }


                        {/* {
                            this.props.noOption ?
                                ''
                                :
                                <div className="multilevel-menu">
                                    <div className="dropdown">

                                        <Button primary={true} className="btn-ivdp-primary btn-theme mr-2 k-primary dropdown-toggle" data-toggle="dropdown">
                                            {("Opções").toUpperCase()} <i className="fas fa-sort-down ml-1 mb-1"></i>
                                        </Button>
                                        {
                                            this.props.optionMenuArray &&
                                            <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                                                {
                                                    this.props.optionMenuArray.length > 0 &&
                                                    this.props.optionMenuArray.map((_option, i) => (
                                                        _option.main &&
                                                            _option.sub_menu ?
                                                            <li key={i} className="dropdown-submenu">
                                                                {
                                                                    this.props.selectedMainOption === _option.main ?
                                                                        <span className="dropdown-item active" tabindex="-1" >{_option.main}</span>
                                                                        :
                                                                        <span className="dropdown-item" tabindex="-1" >{_option.main}</span>
                                                                }
                                                                <ul className="dropdown-menu second-level">
                                                                    {
                                                                        _option.sub_menu.map((lstOption, k) => (
                                                                            this.props.selectedtitelotion === lstOption.display ?
                                                                                <li className="dropdown-item active" onClick={() => this.props.changeOption(i, k)} >{lstOption.display}</li>
                                                                                :
                                                                                <li className="dropdown-item" onClick={() => this.props.changeOption(i, k)} >{lstOption.display}</li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            </li>
                                                            :
                                                            <li className="dropdown-item" >{_option.main}</li>
                                                    ))
                                                }
                                            </ul>

                                        }
                                    </div>
                                </div>


                        } */}


                    </div>

                    {
                        this.props.prevPageName && this.props.prevPageLink ?
                            <>
                                <span onClick={this.goBack} className="custom-well cursor-pointer">Início</span>/<p className="custom-well">
                                    {
                                        (this.props.prevPageName === '1ª avaliação' || this.props.prevPageName === '2ª avaliação') ? "Avaliações pendentes" : this.props.prevPageName
                                    } 
                                </p>
                            </>
                            :
                            (
                                !!this.props.onlyInicioLink ?
                                <span onClick={()=>this.handleInicio()} className="custom-well">Início</span>
                                :
                                <p className="custom-well">Início</p>
                            )
                    }
                </div >
            </div >
        )
    }
}


export default withRouter(TitleBar);